import {
    IonCard,
    IonCardContent,
    IonCardTitle,
    IonCol,
    IonContent,
    IonPage,
    IonRow,
} from "@ionic/react";
import EmailForm from "../../../components/SettingsPage/EmailForm";
import Header from "../../../components/Headers/Header";
import PageTitle from "../../../components/PageTitle/PageTitle";
import React from "react";
import UserAddressForm from "../../../components/Address/UserAddressForm";
import UserPhoneContactForm from "../../../components/Contact/UserPhoneContactForm";

const EditContactPage: React.FC = () => {
    return (
        <IonPage className="bg-light">
            <Header />
            <IonContent>
                <PageTitle title="Edit Contact" />
                <IonRow className="ion-justify-content-center">
                    <IonCol sizeSm="12" sizeMd="10">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>Email Address</IonCardTitle>
                            <IonCardContent>
                                <EmailForm />
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <IonCol sizeSm="12" sizeMd="10">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>Phone Number(s)</IonCardTitle>
                            <IonCardContent>
                                <UserPhoneContactForm />
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
                <IonRow className="ion-justify-content-center">
                    <IonCol sizeSm="12" sizeMd="10">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>Mailing Address</IonCardTitle>
                            <IonCardContent>
                                <UserAddressForm preselectedType="mailing" onSubmit={() => console.log("")} />
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    );
};

export default EditContactPage;